var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-file-input',{attrs:{"label":_vm.label,"rules":_vm.formRules},on:{"change":function($event){return _vm.setDocument($event, '')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }